// extracted by mini-css-extract-plugin
export default {"container":"form_container__FkmH7","btns":"form_btns__3X13t","input":"form_input__GNzIk","error":"form_error__ZjJNp","badgeList":"form_badgeList__undnY"};